<!-- 维修处理 -->
<template>
  <div class="client_form workOrderTem">
    <el-form ref="ruleForm" :model="form" :rules="rules" label-width="160px" class="demo-ruleForm">
      <el-form-item :label="$t('workOrder.cause_analysis')" prop="reason">
        <el-input v-model="form.reason" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.maintenance_scope')" prop="scope">
        <el-input v-model="form.scope" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.precautions')" prop="measure">
        <el-input v-model="form.measure" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.question_category')" prop="problemType">
        <el-select v-model="form.problemType" style="width: 100%;">
          <template v-for="item in problemTypeOptions">
            <el-option :label="$t('workOrder.'+ item.label)" :value="item.value" />
          </template>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('workOrder.remark')" prop="description">
        <el-input v-model="form.description" type="textarea" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.handler')" prop="name">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.processing_time')" prop="handleTime">
        <el-date-picker v-model="form.handleTime" type="datetime" :clearable="false" default-time="14:00:00" value-format="timestamp" style="width: 100%;" />
      </el-form-item>
      <el-form-item :label="$t('workOrder.state_flow')" prop="status">
        <el-select v-model="form.status" style="width: 100%;">
          <template v-for="item in statusOptions">
            <el-option :label="$t('workOrder.'+ item.label)" :value="item.value" />
          </template>
        </el-select>
      </el-form-item>

      <el-form-item class="btnWarp">
        <el-button type="primary" :disabled="subDisabled" @click="submitForm('ruleForm')">{{ isEdit?$t('workOrder.Revise'): $t('workOrder.save') }}</el-button>
        <el-button @click="clickCancel('quxiao')">{{ $t('workOrder.cancel') }}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
import { isObjectValueEqual } from '@/utils'
import { problemTypes } from '../options'
export default {
  components: {},
  props: {
    raw: {}
  },
  data() {
    return {
      attrArr: ['description', 'handleTime', 'id', 'measure', 'name', 'problemType', 'reason', 'scope', 'status'], // 需要对比的属性
      initObj: {}, // 判断是否有改变项--初始化时的值
      newObj: {}, // 判断是否有改变项--最新的值
      subDisabled: false,
      form: {
        description: '',
        handleTime: new Date().getTime(),
        measure: '',
        name: '',
        problemType: '',
        reason: '',
        scope: '',
        status: ''
      },

      statusOptions: [
        { label: 'line_handling', value: 5 },
        { label: 'scrapped', value: 101 }
      ],
      problemTypeOptions: problemTypes,
      user: [],
      isEdit: false// 修改

    }
  },
  computed: {
    rules() {
      return {
        measure: [
          { required: false, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        scope: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        problemType: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        name: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        handleTime: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('workOrder.item_not_empty'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    raw: {
      deep: true,
      handler(obj) {
        this.initForm(obj)
      }
    }
  },
  mounted() {
    this.initForm(this.raw)
  },
  methods: {
    initForm(raw) {
      console.log('维修处理：raw', raw)
      this.isEdit = false
      if (raw.step4) {
        this.form = JSON.parse(raw.step4)
        this.isEdit = true
      }
      var configList = this.$storage.get('configList') || []
      configList.forEach((v, i) => {
        if (v.key == 'user') {
          this.user = v.valueList || []
        }
      })
      this.initObj = this.getObjFn(this.form)
      console.log('initForm:this.form', this.form)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.user && this.form.name != this.user[2]) {
          //   this.$message({
          //     type: 'error',
          //     message: this.$t('workOrder.notPermission')// '提交失败，该处理人无权限，请联系部门负责人'
          //   })
          //   return
          // }
          this.subDisabled = true
          setTimeout(() => {
            this.subDisabled = false
          }, 2000)

          const form = {}
          for (const key in this.raw) {
            if (Object.hasOwnProperty.call(this.raw, key)) {
              const element = this.raw[key]
              form[key] = element
            }
          }
          form.status = this.form.status
          form.step4 = JSON.stringify(this.form)
          this.$emit('save', form)
          console.log(form)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    clickCancel(val) {
      this.newObj = this.getObjFn(this.form)
      this.$emit('back', this.initObj, this.newObj, val)
    },
    getObjFn(obj) {
      var newObj = {}
      this.attrArr.forEach(v => {
        newObj[v] = obj[v]
      })
      return newObj
    }
  }
}
</script>

<style lang='scss' scoped>
.client_form {
  width: 700px;
  margin: 20px auto;
}
</style>
